export default "__VITE_ASSET__Ef_2nKgF__"